import { makeStyles } from "@material-ui/core";

export const useStylesTablero = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: "#323940",
    color: "#CCCCCC",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Arial",
    fontSize: "18.0pt",
    fontWeight: "400",
    textTransform: "uppercase",
  },
  dialogContent: {
    backgroundColor: "#323940",
    color: "#fff",
  },
  dialogActions: {
    backgroundColor: "#323940",
  },
  dialogText: {
    color: "#CCCCCC",
    fontFamily: "Arial",
  },
  btnAceptar: {
    backgroundColor: "#FFFFFF",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnCancelar: {
    backgroundColor: "transparent",
    color: "#FFF",
    // "&:hover": {
    //   backgroundColor: "#357ae8",
    // },
  },
  btnEliminar: {
    backgroundColor: "#e57373",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btn: {
    backgroundColor: "#4d90fe",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnFecha: {
    backgroundColor: "#2C2C2C",
    fontFamily: "Arial",
    color: "#CCCCCC !important",
    borderColor: "#CCCCCC",
    "&:hover": {
      backgroundColor: "gray",
    },
    "& .MuiButton-root.Mui-disabled": {
      color: "#CCCCCC !important",
      backgroundColor: "#2C2C2C",
    }
  },
  fieldNotched: {
    backgroundColor: "#2C2C2C",
    fontFamily: "Arial",
    color: "#CCCCCC",
    borderRadius: "1px",
    "& .MuiFormLabel-root": {
      color: "#000000",
    },
  },
  field: {
    backgroundColor: "#2C2C2C",
    fontFamily: "Arial",
    color: "#CCCCCC",
    borderRadius: "1px",
    "& label.Mui-focused": {
      color: "#CCCCCC",
    },
    "& .MuiFormLabel-root": {
      color: "#CCCCCC",
    },
    "& .MuiInputLabel-root": {
      color: "#CCCCCC",
    },
    "& .MuiOutlinedInput-root": {
      color: "#CCCCCC",
      "& fieldset": {
        borderColor: "#CCCCCC",
      },
      "&:hover fieldset": {
        borderColor: "#1976d2",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#CCCCCC",
      }, 
      '& .MuiInputAdornment-root': {
        position: 'relative',
        cursor: 'pointer',
        zIndex: 2, // Asegura que el ícono personalizado esté sobre el original
        color: '#FFFFFF',
      },
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0, // Oculta el ícono visualmente pero permite la interacción
      zIndex: 1, // Envía el ícono del navegador detrás del personalizado
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
    "& .MuiFormHelperText-root": {
      backgroundColor: "#323940",
      color: "#CCCCCC",
      width: "100%",
      marginLeft: "0",
      marginTop: "0",
      paddingTop: "10px",
      paddingLeft: "10px",
    },
    "& .MuiFormHelperText-contained": {
      backgroundColor: "#323940",
    },
    "& .MuiAutocomplete-noOptions": {
      color: "#CCCCCC",
    },
    "& .MuiPaper-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiMenu-list": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiListItem-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiMenu-paper": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-padding": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
  },
  fieldSelect: {
    backgroundColor: "#454C4F",
    "& .MuiSvgIcon-root": {
      color: "#FFFF",
    },
  },
  autoComplete: {
    "& .MuiAutocomplete-noOptions": {
      color: "#CCCCCC",
    },
  },
  tabla: {
    backgroundColor: "#4E565D",
    "& .MuiTableCell-head": {
      backgroundColor: "#4E565D",
      color: "#C1C2C2",
    },
    "& .MuiInputBase-root": {
      color: "#C1C2C2",
    },
    "& .MuiFormLabel-root": {
      color: "#C1C2C2",
    },
    "& .MuiInputLabel-root": {
      color: "#C1C2C2",
    },
    "& .MuiTableBody-root": {
      backgroundColor: "#4E565D",
      color: "#C1C2C2",
    },
    "& .MuiTypography-root": {
      color: "#C1C2C2",
    },
    "& .MuiCardActions-root": {
      backgroundColor: "#4E565D",
    },
    "& .MuiTableCell-root": {
      backgroundColor: "#4E565D",
    },
    "& .MuiCardContent-root": {
      backgroundColor: "#4E565D",
    },
  },
  tablaPaginacion: {
    backgroundColor: "#4E565D",
    "& .MuiCardActions-root": {
      backgroundColor: "#4E565D",
    },
    "& .MuiTablePagination-root": {
      backgroundColor: "#4E565D",
    },
    "& .MuiToolbar-root": {
      backgroundColor: "#4E565D",
    },
    "& .MuiCardContent-root": {
      backgroundColor: "#4E565D",
    },
  },
  tablaCelda: {
    border: "1px",
    borderColor: "gray",
    borderStyle: "hidden solid solid hidden",
  },
  progressBar: {
    marginBottom: "16px",
    height: "8px",
    borderRadius: "4px",
    backgroundColor: "#CCCCCC",
    "& .MuiLinearProgress-bar1Determinate": {
      backgroundColor: "#357ae8",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  },
  accordion: {
    background: "#2d3239",
    color: "#ffffff",
  },
  menu: {
    "& .MuiPaper-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiMenu-list": {
      backgroundColor: "#2d3239",
    },
    "& .MuiListItem-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "gray",
      },
    },
    "& .MuiMenu-paper": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-padding": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
  },
  menuItem: {
    backgroundColor: "#2d3239",
    color: "#ffffff",
    margin: "-8px",
    "&:hover": {
      backgroundColor: "gray",
    },
    "& .MuiPaper-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiMenu-list": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiListItem-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiMenu-paper": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-padding": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
    "& .MuiList-root": {
      backgroundColor: "#2d3239",
      color: "#ffffff",
    },
  },
}));
